import { SmartSessionType } from '../models/smart_sessions.types'

export const ONBOARDING_ORGANIZED_SESSION_ID_KEY = 'SkipperOrganizedSessionId'
export const ONBOARDING_SKIPPED_CLEANUP_KEY = 'SkipperSessionCleanupSkipped'

const MINIMUM_SESSIONS = 1

export const hasValidSessions = (sessions: SmartSessionType[] | undefined): boolean => {
  if (!sessions) {
    return false
  }

  if (!Array.isArray(sessions)) {
    return false
  }

  if (sessions.length <= MINIMUM_SESSIONS) {
    return false
  }

  return true
}

export const getOldestSession = (sessions: SmartSessionType[] | undefined) => {
  if (!sessions) {
    return undefined
  }

  const organizedSessionId = localStorage.getItem(ONBOARDING_ORGANIZED_SESSION_ID_KEY)
  const uniqueSessions = sessions?.filter((session) => session.id.toString() !== organizedSessionId)
  const sessionsWithOpenTabs = uniqueSessions?.filter((session) =>
    session.pages.some((page) => page.is_open),
  )
  const filteredSessions = sessionsWithOpenTabs?.filter((session) =>
    session.pages.some((page) => {
      const oneHourAgo = Date.now() - 60 * 60 * 1000
      return page.last_access_timestamp_ms < oneHourAgo
    }),
  )

  if (!filteredSessions || filteredSessions.length === 0) {
    return undefined
  }

  // Sort sessions by their start timestamp in ascending order to get the oldest session
  const sortedSessions = [...(filteredSessions ?? [])].sort(
    (a, b) => a.datetime_start_ts - b.datetime_start_ts,
  )

  // Find the session with at least one open page that has the oldest last_access_timestamp_ms
  const sessionsWithOpenPages = sortedSessions.sort((a, b) => {
    const oldestPageA = Math.min(
      ...a.pages.filter((page) => page.is_open).map((page) => page.last_access_timestamp_ms),
    )
    const oldestPageB = Math.min(
      ...b.pages.filter((page) => page.is_open).map((page) => page.last_access_timestamp_ms),
    )
    return oldestPageA - oldestPageB
  })

  // If no sessions with open pages that haven't been viewed recently are found, fall back to the most recent session
  return sessionsWithOpenPages.length > 0 ? sessionsWithOpenPages[0] : sortedSessions[0]
}
